import onReady from '../utils/onReady';
import Flickity from 'flickity';


/**
 * Flickity image slider
 *
 * @param {HTMLElement} .main-carousel
 * @constructor
 */
class ImageSlider {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} .main-carousel
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} .main-carousel
     */
    init(container) {

        this.dom = {
            container // ES6 allows this syntax instead of writing "container: container"
        };

        this.numberOfSlides = this.dom.container.getAttribute("data-number-of-slides") || this.dom.container.children.length;

        // Put your other DOM-specific initializations here, and get your class moving!

        this.settings();

    }


    settings() {
        let useSliderNavigation = true;
        if (this.numberOfSlides && this.numberOfSlides == 1) {
            useSliderNavigation = false;
        }

        // eslint-disable-next-line
        let slider = new Flickity(this.dom.container, {
            // Options
            "wrapAround": true,
            "setGallerySize": true, // Set container size equal to the highest image
            "imagesLoaded": true, // Wait for images to be loaded
            "prevNextButtons": useSliderNavigation,
            "pageDots": useSliderNavigation,
            arrowShape: {
                x0: 30,
                x1: 55, y1: 25,
                x2: 60, y2: 20,
                x3: 40
            }
        });

        if (slider.nextButton) {
            slider.nextButton.element.setAttribute("aria-label", "Næste billede");
        }

        if (slider.prevButton) {
            slider.prevButton.element.setAttribute("aria-label", "Forrige billede")
        }
    }
}


export default ImageSlider;